import { getContractBasedDataSelector } from '@cp-shared-15/frontend-integration';
import { RootState } from 'store/rootReducer';

export const VehicleImageDataSelector = getContractBasedDataSelector(
    (state: RootState) => state.vehicleDetailsAndImage.vehicleImages,
);
